/**
 * Admin portal UI theme / branding surface.
 * Colors: ThemeTokens (CSS vars). Logo: replace `src/assets/logo.png` and bump logoVersion.
 * Runtime brand overrides are applied by ThemeService from api/admin-theme.
 */
import { ThemeTokens } from "./theme-tokens";

export { ThemeTokens };
export type { ThemeToken } from "./theme-tokens";

const logoFile = "assets/logo.png";
const logoVersion = "2026-png";

export const AppTheme = {
  /** Color tokens (CSS custom properties). */
  tokens: ThemeTokens,

  /** Path under `src/assets` — keep favicon/manifest pointing at the same file. */
  logoFile,

  /** Bump after replacing the logo file to bust browser cache. */
  logoVersion,

  /** Resolved logo URL used by login, side nav, and letter previews. */
  logoSrc: `${logoFile}?v=${logoVersion}`,
} as const;
